import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import { Col, Row } from 'reactstrap'
import { Button } from '@/components/button'
import { NumericInput } from '@/components/inputs'
import context from '@/context'
import { openConfirmDialog, openErrorDialog } from '@/utils/dialogHelpers'

const FilterNumbers = React.memo(() => {
  const [ filterNumbers, setFilterNumbers ] = useState([])
  const [ inputValue, setInputValue ] = useState(null)
  const [ isLoading, setIsLoading ] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    context.api.institutionReportGroupService.getAccountFilters()
      .then(response => {
        setFilterNumbers(response)
        setIsLoading(false)
      })
      .catch(openErrorDialog)
  }, [])

  const onAddFilterNumber = useCallback(() => {
    const value = inputValue
    setIsLoading(true)
    context.api.institutionReportGroupService.addAccountFilter(value)
      .then(r => {
        setIsLoading(false)
        setInputValue(null)
        setFilterNumbers([ ...filterNumbers, value ])
      })
      .catch(openErrorDialog)
  }, [filterNumbers, inputValue])

  const onRemoveFilterNumber = useCallback((value) => {
    openConfirmDialog({
      customTitle: 'Reporting.DeleteAccountFilter',
      customConfirmText: 'Reporting.DeleteAccountFilterText',
      onAction: () => {
        setIsLoading(true)
        context.api.institutionReportGroupService.deleteAccountFilter(value)
          .then(r => {
            setFilterNumbers(filterNumbers.filter(x => x !== value))
            setIsLoading(false)
          })
          .catch(c => openErrorDialog())
      }
    })
  }, [filterNumbers])

  const doesFilterExist = useMemo(() => !!filterNumbers.find(x => x === inputValue), [filterNumbers, inputValue])

  return <WhiteBox header='Reporting.FilterNumbers'>
    <Row>
      <Col sm={2}>
        <Button onClick={onAddFilterNumber} disabled={!inputValue || doesFilterExist || isLoading} className={'btn btn-success'} icon='plus'>
          <Resx name='Reporting.AddAccountIdFilter' />
        </Button>
      </Col>
      <Col sm={10}>
        <NumericInput value={inputValue} integerOnly onChange={setInputValue} />
      </Col>
      {filterNumbers.map(x => <React.Fragment>
        <Col sm={2}>{x}</Col>
        <Col sm={10}>{<Button disabled={isLoading} icon='trash' iconOnly onClick={() => onRemoveFilterNumber(x)} />}</Col>
      </React.Fragment>)}
    </Row>
  </WhiteBox>
})

export { FilterNumbers }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/icbsReportAdministration/filterNumbers.js